import { Box } from '@offline-mui/material'
import type { SxProps, Theme } from '@offline-mui/material'

/** Fixed tinted pairs (background, text). Assigned by hashing the carrier
 *  code so the same airline always gets the same colour. */
const PALETTE: ReadonlyArray<readonly [string, string]> = [
  ['#DBEAFE', '#1E40AF'],
  ['#FEE2E2', '#991B1B'],
  ['#DCFCE7', '#166534'],
  ['#FEF3C7', '#92400E'],
  ['#EDE9FE', '#5B21B6'],
  ['#CCFBF1', '#115E59'],
  ['#FCE7F3', '#9D174D'],
  ['#E0E7FF', '#3730A3'],
]

export function carrierColors(code: string | null | undefined) {
  if (!code) return ['#F1F5F9', '#64748B'] as const
  let hash = 0
  for (const char of code.toUpperCase()) hash = (hash * 31 + char.charCodeAt(0)) >>> 0
  return PALETTE[hash % PALETTE.length]
}

type CarrierBadgeProps = {
  code: string | null | undefined
  size?: 'small' | 'medium'
  sx?: SxProps<Theme>
}

export default function CarrierBadge({ code, size = 'medium', sx }: CarrierBadgeProps) {
  const [bg, fg] = carrierColors(code)
  const small = size === 'small'
  return (
    <Box
      component="span"
      sx={[
        {
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: small ? 34 : 42,
          height: small ? 24 : 30,
          px: 1,
          borderRadius: small ? 1.5 : 2,
          bgcolor: bg,
          color: fg,
          fontWeight: 800,
          fontSize: small ? 11.5 : 13,
          letterSpacing: '0.04em',
          flexShrink: 0,
          lineHeight: 1,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {code || '—'}
    </Box>
  )
}
